import { Component, Inject, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-payment-initialize',
  standalone: false,
  templateUrl: './payment-initialize.component.html',
  styleUrl: './payment-initialize.component.scss',
})
export class PaymentInitializeComponent implements OnInit {
  amount: number;
  paymentType: string; // debit, credit
  isLoadingInterswitch: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PaymentInitializeComponent>,
    private apiService: ApiService
  ) {
    this.amount = data?.amount;
    this.paymentType = data?.paymentType;
  }

  ngOnInit(): void {
    this.startInterswitch();

  }

  startInterswitch() {
    const url = '/payment/initialize';
    const details = {
      paymentAmount: this.amount,
      paymentType: this.paymentType,
    };
    this.apiService.post(url, details).subscribe({
      next: (response) => {
        this.isLoadingInterswitch = false;
        this.checkout(response.data);
      },
      error: (error) => {
        this.isLoadingInterswitch = false;
        console.info(`Unable to reach Interswitch: ${error}`);
      },
    });
  }

  checkout(details: any) {
    var paymentRequest = {
      merchant_code: details?.merchantCode,
      pay_item_id: details?.payItemId,
      txn_ref: details?.orderId,
      cust_id: details?.customerId,
      amount: Math.round((details?.amount * 100 + Number.EPSILON) * 100) / 100,
      currency: '566',
      site_redirect_url: window.location.origin,
      onComplete: (response: any) => this.paymentCallback(response),
      mode: details?.mode,
    };

    if (
      details?.mode === 'LIVE' &&
      details?.splitAccounts &&
      Object.keys(details?.splitAccounts).length > 0
    ) {
      paymentRequest['split_accounts'] = JSON.stringify(details?.splitAccounts);
    }

    (window as any).webpayCheckout(paymentRequest);
  }

  paymentCallback(response: any) {

    if (response != null && parseFloat(response.amount) > 0) {
      setTimeout(() => {
        window.open('/payment/return-back/' + response.txnref, '_self');
      }, 50);
    }else{
      alert('Payment was not successful');
    }
    this.dialogRef.close()

  }

}
